/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as AdminCurrentAdminLoginImport } from './routes/admin/current-admin-login'

// Create Virtual Routes

const VacanciesLazyImport = createFileRoute('/vacancies')()
const UserLazyImport = createFileRoute('/user')()
const RegisterLazyImport = createFileRoute('/register')()
const PolicyPageLazyImport = createFileRoute('/policy-page')()
const LoginLazyImport = createFileRoute('/login')()
const CreateVacancyLazyImport = createFileRoute('/create-vacancy')()
const CreateResumeLazyImport = createFileRoute('/create-resume')()
const ContactsLazyImport = createFileRoute('/contacts')()
const BlogLazyImport = createFileRoute('/blog')()
const AccountRoleChoiceLazyImport = createFileRoute('/account-role-choice')()
const AboutLazyImport = createFileRoute('/about')()
const IndexLazyImport = createFileRoute('/')()
const ReportIdLazyImport = createFileRoute('/report/$id')()
const PostIdLazyImport = createFileRoute('/post/$id')()
const PasswordIdLazyImport = createFileRoute('/password/$id')()
const AdminHomePageLazyImport = createFileRoute('/admin/home-page')()
const AdminGlobalLoginLazyImport = createFileRoute('/admin/global-login')()
const AccountIdLazyImport = createFileRoute('/account/$id')()
const VacancyViewAllCandidatesLazyImport = createFileRoute(
  '/vacancy/view/all-candidates',
)()
const VacancyViewIdLazyImport = createFileRoute('/vacancy/view/$id')()
const VacancyEditIdLazyImport = createFileRoute('/vacancy/edit/$id')()
const VacancyApplyIdLazyImport = createFileRoute('/vacancy/apply/$id')()
const ResumeViewIdLazyImport = createFileRoute('/resume/view/$id')()
const ResumeUploadFileLazyImport = createFileRoute('/resume/upload/file')()
const ResumeEditIdLazyImport = createFileRoute('/resume/edit/$id')()
const AdminReportEditLazyImport = createFileRoute('/admin/report/edit')()
const AdminBlogEditLazyImport = createFileRoute('/admin/blog/edit')()
const AccountCallbackUserTypeLazyImport = createFileRoute(
  '/account/callback/$userType',
)()
const ResumeViewFileIdLazyImport = createFileRoute('/resume/view/file/$id')()

// Create/Update Routes

const VacanciesLazyRoute = VacanciesLazyImport.update({
  id: '/vacancies',
  path: '/vacancies',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/vacancies.lazy').then((d) => d.Route))

const UserLazyRoute = UserLazyImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/user.lazy').then((d) => d.Route))

const RegisterLazyRoute = RegisterLazyImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/register.lazy').then((d) => d.Route))

const PolicyPageLazyRoute = PolicyPageLazyImport.update({
  id: '/policy-page',
  path: '/policy-page',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/policy-page.lazy').then((d) => d.Route))

const LoginLazyRoute = LoginLazyImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/login.lazy').then((d) => d.Route))

const CreateVacancyLazyRoute = CreateVacancyLazyImport.update({
  id: '/create-vacancy',
  path: '/create-vacancy',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/create-vacancy.lazy').then((d) => d.Route),
)

const CreateResumeLazyRoute = CreateResumeLazyImport.update({
  id: '/create-resume',
  path: '/create-resume',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/create-resume.lazy').then((d) => d.Route))

const ContactsLazyRoute = ContactsLazyImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/contacts.lazy').then((d) => d.Route))

const BlogLazyRoute = BlogLazyImport.update({
  id: '/blog',
  path: '/blog',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/blog.lazy').then((d) => d.Route))

const AccountRoleChoiceLazyRoute = AccountRoleChoiceLazyImport.update({
  id: '/account-role-choice',
  path: '/account-role-choice',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/account-role-choice.lazy').then((d) => d.Route),
)

const AboutLazyRoute = AboutLazyImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/about.lazy').then((d) => d.Route))

const IndexLazyRoute = IndexLazyImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))

const ReportIdLazyRoute = ReportIdLazyImport.update({
  id: '/report/$id',
  path: '/report/$id',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/report/$id.lazy').then((d) => d.Route))

const PostIdLazyRoute = PostIdLazyImport.update({
  id: '/post/$id',
  path: '/post/$id',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/post/$id.lazy').then((d) => d.Route))

const PasswordIdLazyRoute = PasswordIdLazyImport.update({
  id: '/password/$id',
  path: '/password/$id',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/password/$id.lazy').then((d) => d.Route))

const AdminHomePageLazyRoute = AdminHomePageLazyImport.update({
  id: '/admin/home-page',
  path: '/admin/home-page',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/admin/home-page.lazy').then((d) => d.Route),
)

const AdminGlobalLoginLazyRoute = AdminGlobalLoginLazyImport.update({
  id: '/admin/global-login',
  path: '/admin/global-login',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/admin/global-login.lazy').then((d) => d.Route),
)

const AccountIdLazyRoute = AccountIdLazyImport.update({
  id: '/account/$id',
  path: '/account/$id',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/account/$id.lazy').then((d) => d.Route))

const AdminCurrentAdminLoginRoute = AdminCurrentAdminLoginImport.update({
  id: '/admin/current-admin-login',
  path: '/admin/current-admin-login',
  getParentRoute: () => rootRoute,
} as any)

const VacancyViewAllCandidatesLazyRoute =
  VacancyViewAllCandidatesLazyImport.update({
    id: '/vacancy/view/all-candidates',
    path: '/vacancy/view/all-candidates',
    getParentRoute: () => rootRoute,
  } as any).lazy(() =>
    import('./routes/vacancy/view/all-candidates.lazy').then((d) => d.Route),
  )

const VacancyViewIdLazyRoute = VacancyViewIdLazyImport.update({
  id: '/vacancy/view/$id',
  path: '/vacancy/view/$id',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/vacancy/view/$id.lazy').then((d) => d.Route),
)

const VacancyEditIdLazyRoute = VacancyEditIdLazyImport.update({
  id: '/vacancy/edit/$id',
  path: '/vacancy/edit/$id',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/vacancy/edit/$id.lazy').then((d) => d.Route),
)

const VacancyApplyIdLazyRoute = VacancyApplyIdLazyImport.update({
  id: '/vacancy/apply/$id',
  path: '/vacancy/apply/$id',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/vacancy/apply/$id.lazy').then((d) => d.Route),
)

const ResumeViewIdLazyRoute = ResumeViewIdLazyImport.update({
  id: '/resume/view/$id',
  path: '/resume/view/$id',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/resume/view/$id.lazy').then((d) => d.Route),
)

const ResumeUploadFileLazyRoute = ResumeUploadFileLazyImport.update({
  id: '/resume/upload/file',
  path: '/resume/upload/file',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/resume/upload/file.lazy').then((d) => d.Route),
)

const ResumeEditIdLazyRoute = ResumeEditIdLazyImport.update({
  id: '/resume/edit/$id',
  path: '/resume/edit/$id',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/resume/edit/$id.lazy').then((d) => d.Route),
)

const AdminReportEditLazyRoute = AdminReportEditLazyImport.update({
  id: '/admin/report/edit',
  path: '/admin/report/edit',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/admin/report/edit.lazy').then((d) => d.Route),
)

const AdminBlogEditLazyRoute = AdminBlogEditLazyImport.update({
  id: '/admin/blog/edit',
  path: '/admin/blog/edit',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/admin/blog/edit.lazy').then((d) => d.Route),
)

const AccountCallbackUserTypeLazyRoute =
  AccountCallbackUserTypeLazyImport.update({
    id: '/account/callback/$userType',
    path: '/account/callback/$userType',
    getParentRoute: () => rootRoute,
  } as any).lazy(() =>
    import('./routes/account/callback/$userType.lazy').then((d) => d.Route),
  )

const ResumeViewFileIdLazyRoute = ResumeViewFileIdLazyImport.update({
  id: '/resume/view/file/$id',
  path: '/resume/view/file/$id',
  getParentRoute: () => rootRoute,
} as any).lazy(() =>
  import('./routes/resume/view/file/$id.lazy').then((d) => d.Route),
)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutLazyImport
      parentRoute: typeof rootRoute
    }
    '/account-role-choice': {
      id: '/account-role-choice'
      path: '/account-role-choice'
      fullPath: '/account-role-choice'
      preLoaderRoute: typeof AccountRoleChoiceLazyImport
      parentRoute: typeof rootRoute
    }
    '/blog': {
      id: '/blog'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof BlogLazyImport
      parentRoute: typeof rootRoute
    }
    '/contacts': {
      id: '/contacts'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof ContactsLazyImport
      parentRoute: typeof rootRoute
    }
    '/create-resume': {
      id: '/create-resume'
      path: '/create-resume'
      fullPath: '/create-resume'
      preLoaderRoute: typeof CreateResumeLazyImport
      parentRoute: typeof rootRoute
    }
    '/create-vacancy': {
      id: '/create-vacancy'
      path: '/create-vacancy'
      fullPath: '/create-vacancy'
      preLoaderRoute: typeof CreateVacancyLazyImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginLazyImport
      parentRoute: typeof rootRoute
    }
    '/policy-page': {
      id: '/policy-page'
      path: '/policy-page'
      fullPath: '/policy-page'
      preLoaderRoute: typeof PolicyPageLazyImport
      parentRoute: typeof rootRoute
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterLazyImport
      parentRoute: typeof rootRoute
    }
    '/user': {
      id: '/user'
      path: '/user'
      fullPath: '/user'
      preLoaderRoute: typeof UserLazyImport
      parentRoute: typeof rootRoute
    }
    '/vacancies': {
      id: '/vacancies'
      path: '/vacancies'
      fullPath: '/vacancies'
      preLoaderRoute: typeof VacanciesLazyImport
      parentRoute: typeof rootRoute
    }
    '/admin/current-admin-login': {
      id: '/admin/current-admin-login'
      path: '/admin/current-admin-login'
      fullPath: '/admin/current-admin-login'
      preLoaderRoute: typeof AdminCurrentAdminLoginImport
      parentRoute: typeof rootRoute
    }
    '/account/$id': {
      id: '/account/$id'
      path: '/account/$id'
      fullPath: '/account/$id'
      preLoaderRoute: typeof AccountIdLazyImport
      parentRoute: typeof rootRoute
    }
    '/admin/global-login': {
      id: '/admin/global-login'
      path: '/admin/global-login'
      fullPath: '/admin/global-login'
      preLoaderRoute: typeof AdminGlobalLoginLazyImport
      parentRoute: typeof rootRoute
    }
    '/admin/home-page': {
      id: '/admin/home-page'
      path: '/admin/home-page'
      fullPath: '/admin/home-page'
      preLoaderRoute: typeof AdminHomePageLazyImport
      parentRoute: typeof rootRoute
    }
    '/password/$id': {
      id: '/password/$id'
      path: '/password/$id'
      fullPath: '/password/$id'
      preLoaderRoute: typeof PasswordIdLazyImport
      parentRoute: typeof rootRoute
    }
    '/post/$id': {
      id: '/post/$id'
      path: '/post/$id'
      fullPath: '/post/$id'
      preLoaderRoute: typeof PostIdLazyImport
      parentRoute: typeof rootRoute
    }
    '/report/$id': {
      id: '/report/$id'
      path: '/report/$id'
      fullPath: '/report/$id'
      preLoaderRoute: typeof ReportIdLazyImport
      parentRoute: typeof rootRoute
    }
    '/account/callback/$userType': {
      id: '/account/callback/$userType'
      path: '/account/callback/$userType'
      fullPath: '/account/callback/$userType'
      preLoaderRoute: typeof AccountCallbackUserTypeLazyImport
      parentRoute: typeof rootRoute
    }
    '/admin/blog/edit': {
      id: '/admin/blog/edit'
      path: '/admin/blog/edit'
      fullPath: '/admin/blog/edit'
      preLoaderRoute: typeof AdminBlogEditLazyImport
      parentRoute: typeof rootRoute
    }
    '/admin/report/edit': {
      id: '/admin/report/edit'
      path: '/admin/report/edit'
      fullPath: '/admin/report/edit'
      preLoaderRoute: typeof AdminReportEditLazyImport
      parentRoute: typeof rootRoute
    }
    '/resume/edit/$id': {
      id: '/resume/edit/$id'
      path: '/resume/edit/$id'
      fullPath: '/resume/edit/$id'
      preLoaderRoute: typeof ResumeEditIdLazyImport
      parentRoute: typeof rootRoute
    }
    '/resume/upload/file': {
      id: '/resume/upload/file'
      path: '/resume/upload/file'
      fullPath: '/resume/upload/file'
      preLoaderRoute: typeof ResumeUploadFileLazyImport
      parentRoute: typeof rootRoute
    }
    '/resume/view/$id': {
      id: '/resume/view/$id'
      path: '/resume/view/$id'
      fullPath: '/resume/view/$id'
      preLoaderRoute: typeof ResumeViewIdLazyImport
      parentRoute: typeof rootRoute
    }
    '/vacancy/apply/$id': {
      id: '/vacancy/apply/$id'
      path: '/vacancy/apply/$id'
      fullPath: '/vacancy/apply/$id'
      preLoaderRoute: typeof VacancyApplyIdLazyImport
      parentRoute: typeof rootRoute
    }
    '/vacancy/edit/$id': {
      id: '/vacancy/edit/$id'
      path: '/vacancy/edit/$id'
      fullPath: '/vacancy/edit/$id'
      preLoaderRoute: typeof VacancyEditIdLazyImport
      parentRoute: typeof rootRoute
    }
    '/vacancy/view/$id': {
      id: '/vacancy/view/$id'
      path: '/vacancy/view/$id'
      fullPath: '/vacancy/view/$id'
      preLoaderRoute: typeof VacancyViewIdLazyImport
      parentRoute: typeof rootRoute
    }
    '/vacancy/view/all-candidates': {
      id: '/vacancy/view/all-candidates'
      path: '/vacancy/view/all-candidates'
      fullPath: '/vacancy/view/all-candidates'
      preLoaderRoute: typeof VacancyViewAllCandidatesLazyImport
      parentRoute: typeof rootRoute
    }
    '/resume/view/file/$id': {
      id: '/resume/view/file/$id'
      path: '/resume/view/file/$id'
      fullPath: '/resume/view/file/$id'
      preLoaderRoute: typeof ResumeViewFileIdLazyImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/about': typeof AboutLazyRoute
  '/account-role-choice': typeof AccountRoleChoiceLazyRoute
  '/blog': typeof BlogLazyRoute
  '/contacts': typeof ContactsLazyRoute
  '/create-resume': typeof CreateResumeLazyRoute
  '/create-vacancy': typeof CreateVacancyLazyRoute
  '/login': typeof LoginLazyRoute
  '/policy-page': typeof PolicyPageLazyRoute
  '/register': typeof RegisterLazyRoute
  '/user': typeof UserLazyRoute
  '/vacancies': typeof VacanciesLazyRoute
  '/admin/current-admin-login': typeof AdminCurrentAdminLoginRoute
  '/account/$id': typeof AccountIdLazyRoute
  '/admin/global-login': typeof AdminGlobalLoginLazyRoute
  '/admin/home-page': typeof AdminHomePageLazyRoute
  '/password/$id': typeof PasswordIdLazyRoute
  '/post/$id': typeof PostIdLazyRoute
  '/report/$id': typeof ReportIdLazyRoute
  '/account/callback/$userType': typeof AccountCallbackUserTypeLazyRoute
  '/admin/blog/edit': typeof AdminBlogEditLazyRoute
  '/admin/report/edit': typeof AdminReportEditLazyRoute
  '/resume/edit/$id': typeof ResumeEditIdLazyRoute
  '/resume/upload/file': typeof ResumeUploadFileLazyRoute
  '/resume/view/$id': typeof ResumeViewIdLazyRoute
  '/vacancy/apply/$id': typeof VacancyApplyIdLazyRoute
  '/vacancy/edit/$id': typeof VacancyEditIdLazyRoute
  '/vacancy/view/$id': typeof VacancyViewIdLazyRoute
  '/vacancy/view/all-candidates': typeof VacancyViewAllCandidatesLazyRoute
  '/resume/view/file/$id': typeof ResumeViewFileIdLazyRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/about': typeof AboutLazyRoute
  '/account-role-choice': typeof AccountRoleChoiceLazyRoute
  '/blog': typeof BlogLazyRoute
  '/contacts': typeof ContactsLazyRoute
  '/create-resume': typeof CreateResumeLazyRoute
  '/create-vacancy': typeof CreateVacancyLazyRoute
  '/login': typeof LoginLazyRoute
  '/policy-page': typeof PolicyPageLazyRoute
  '/register': typeof RegisterLazyRoute
  '/user': typeof UserLazyRoute
  '/vacancies': typeof VacanciesLazyRoute
  '/admin/current-admin-login': typeof AdminCurrentAdminLoginRoute
  '/account/$id': typeof AccountIdLazyRoute
  '/admin/global-login': typeof AdminGlobalLoginLazyRoute
  '/admin/home-page': typeof AdminHomePageLazyRoute
  '/password/$id': typeof PasswordIdLazyRoute
  '/post/$id': typeof PostIdLazyRoute
  '/report/$id': typeof ReportIdLazyRoute
  '/account/callback/$userType': typeof AccountCallbackUserTypeLazyRoute
  '/admin/blog/edit': typeof AdminBlogEditLazyRoute
  '/admin/report/edit': typeof AdminReportEditLazyRoute
  '/resume/edit/$id': typeof ResumeEditIdLazyRoute
  '/resume/upload/file': typeof ResumeUploadFileLazyRoute
  '/resume/view/$id': typeof ResumeViewIdLazyRoute
  '/vacancy/apply/$id': typeof VacancyApplyIdLazyRoute
  '/vacancy/edit/$id': typeof VacancyEditIdLazyRoute
  '/vacancy/view/$id': typeof VacancyViewIdLazyRoute
  '/vacancy/view/all-candidates': typeof VacancyViewAllCandidatesLazyRoute
  '/resume/view/file/$id': typeof ResumeViewFileIdLazyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexLazyRoute
  '/about': typeof AboutLazyRoute
  '/account-role-choice': typeof AccountRoleChoiceLazyRoute
  '/blog': typeof BlogLazyRoute
  '/contacts': typeof ContactsLazyRoute
  '/create-resume': typeof CreateResumeLazyRoute
  '/create-vacancy': typeof CreateVacancyLazyRoute
  '/login': typeof LoginLazyRoute
  '/policy-page': typeof PolicyPageLazyRoute
  '/register': typeof RegisterLazyRoute
  '/user': typeof UserLazyRoute
  '/vacancies': typeof VacanciesLazyRoute
  '/admin/current-admin-login': typeof AdminCurrentAdminLoginRoute
  '/account/$id': typeof AccountIdLazyRoute
  '/admin/global-login': typeof AdminGlobalLoginLazyRoute
  '/admin/home-page': typeof AdminHomePageLazyRoute
  '/password/$id': typeof PasswordIdLazyRoute
  '/post/$id': typeof PostIdLazyRoute
  '/report/$id': typeof ReportIdLazyRoute
  '/account/callback/$userType': typeof AccountCallbackUserTypeLazyRoute
  '/admin/blog/edit': typeof AdminBlogEditLazyRoute
  '/admin/report/edit': typeof AdminReportEditLazyRoute
  '/resume/edit/$id': typeof ResumeEditIdLazyRoute
  '/resume/upload/file': typeof ResumeUploadFileLazyRoute
  '/resume/view/$id': typeof ResumeViewIdLazyRoute
  '/vacancy/apply/$id': typeof VacancyApplyIdLazyRoute
  '/vacancy/edit/$id': typeof VacancyEditIdLazyRoute
  '/vacancy/view/$id': typeof VacancyViewIdLazyRoute
  '/vacancy/view/all-candidates': typeof VacancyViewAllCandidatesLazyRoute
  '/resume/view/file/$id': typeof ResumeViewFileIdLazyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/account-role-choice'
    | '/blog'
    | '/contacts'
    | '/create-resume'
    | '/create-vacancy'
    | '/login'
    | '/policy-page'
    | '/register'
    | '/user'
    | '/vacancies'
    | '/admin/current-admin-login'
    | '/account/$id'
    | '/admin/global-login'
    | '/admin/home-page'
    | '/password/$id'
    | '/post/$id'
    | '/report/$id'
    | '/account/callback/$userType'
    | '/admin/blog/edit'
    | '/admin/report/edit'
    | '/resume/edit/$id'
    | '/resume/upload/file'
    | '/resume/view/$id'
    | '/vacancy/apply/$id'
    | '/vacancy/edit/$id'
    | '/vacancy/view/$id'
    | '/vacancy/view/all-candidates'
    | '/resume/view/file/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/account-role-choice'
    | '/blog'
    | '/contacts'
    | '/create-resume'
    | '/create-vacancy'
    | '/login'
    | '/policy-page'
    | '/register'
    | '/user'
    | '/vacancies'
    | '/admin/current-admin-login'
    | '/account/$id'
    | '/admin/global-login'
    | '/admin/home-page'
    | '/password/$id'
    | '/post/$id'
    | '/report/$id'
    | '/account/callback/$userType'
    | '/admin/blog/edit'
    | '/admin/report/edit'
    | '/resume/edit/$id'
    | '/resume/upload/file'
    | '/resume/view/$id'
    | '/vacancy/apply/$id'
    | '/vacancy/edit/$id'
    | '/vacancy/view/$id'
    | '/vacancy/view/all-candidates'
    | '/resume/view/file/$id'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/account-role-choice'
    | '/blog'
    | '/contacts'
    | '/create-resume'
    | '/create-vacancy'
    | '/login'
    | '/policy-page'
    | '/register'
    | '/user'
    | '/vacancies'
    | '/admin/current-admin-login'
    | '/account/$id'
    | '/admin/global-login'
    | '/admin/home-page'
    | '/password/$id'
    | '/post/$id'
    | '/report/$id'
    | '/account/callback/$userType'
    | '/admin/blog/edit'
    | '/admin/report/edit'
    | '/resume/edit/$id'
    | '/resume/upload/file'
    | '/resume/view/$id'
    | '/vacancy/apply/$id'
    | '/vacancy/edit/$id'
    | '/vacancy/view/$id'
    | '/vacancy/view/all-candidates'
    | '/resume/view/file/$id'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  AboutLazyRoute: typeof AboutLazyRoute
  AccountRoleChoiceLazyRoute: typeof AccountRoleChoiceLazyRoute
  BlogLazyRoute: typeof BlogLazyRoute
  ContactsLazyRoute: typeof ContactsLazyRoute
  CreateResumeLazyRoute: typeof CreateResumeLazyRoute
  CreateVacancyLazyRoute: typeof CreateVacancyLazyRoute
  LoginLazyRoute: typeof LoginLazyRoute
  PolicyPageLazyRoute: typeof PolicyPageLazyRoute
  RegisterLazyRoute: typeof RegisterLazyRoute
  UserLazyRoute: typeof UserLazyRoute
  VacanciesLazyRoute: typeof VacanciesLazyRoute
  AdminCurrentAdminLoginRoute: typeof AdminCurrentAdminLoginRoute
  AccountIdLazyRoute: typeof AccountIdLazyRoute
  AdminGlobalLoginLazyRoute: typeof AdminGlobalLoginLazyRoute
  AdminHomePageLazyRoute: typeof AdminHomePageLazyRoute
  PasswordIdLazyRoute: typeof PasswordIdLazyRoute
  PostIdLazyRoute: typeof PostIdLazyRoute
  ReportIdLazyRoute: typeof ReportIdLazyRoute
  AccountCallbackUserTypeLazyRoute: typeof AccountCallbackUserTypeLazyRoute
  AdminBlogEditLazyRoute: typeof AdminBlogEditLazyRoute
  AdminReportEditLazyRoute: typeof AdminReportEditLazyRoute
  ResumeEditIdLazyRoute: typeof ResumeEditIdLazyRoute
  ResumeUploadFileLazyRoute: typeof ResumeUploadFileLazyRoute
  ResumeViewIdLazyRoute: typeof ResumeViewIdLazyRoute
  VacancyApplyIdLazyRoute: typeof VacancyApplyIdLazyRoute
  VacancyEditIdLazyRoute: typeof VacancyEditIdLazyRoute
  VacancyViewIdLazyRoute: typeof VacancyViewIdLazyRoute
  VacancyViewAllCandidatesLazyRoute: typeof VacancyViewAllCandidatesLazyRoute
  ResumeViewFileIdLazyRoute: typeof ResumeViewFileIdLazyRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  AboutLazyRoute: AboutLazyRoute,
  AccountRoleChoiceLazyRoute: AccountRoleChoiceLazyRoute,
  BlogLazyRoute: BlogLazyRoute,
  ContactsLazyRoute: ContactsLazyRoute,
  CreateResumeLazyRoute: CreateResumeLazyRoute,
  CreateVacancyLazyRoute: CreateVacancyLazyRoute,
  LoginLazyRoute: LoginLazyRoute,
  PolicyPageLazyRoute: PolicyPageLazyRoute,
  RegisterLazyRoute: RegisterLazyRoute,
  UserLazyRoute: UserLazyRoute,
  VacanciesLazyRoute: VacanciesLazyRoute,
  AdminCurrentAdminLoginRoute: AdminCurrentAdminLoginRoute,
  AccountIdLazyRoute: AccountIdLazyRoute,
  AdminGlobalLoginLazyRoute: AdminGlobalLoginLazyRoute,
  AdminHomePageLazyRoute: AdminHomePageLazyRoute,
  PasswordIdLazyRoute: PasswordIdLazyRoute,
  PostIdLazyRoute: PostIdLazyRoute,
  ReportIdLazyRoute: ReportIdLazyRoute,
  AccountCallbackUserTypeLazyRoute: AccountCallbackUserTypeLazyRoute,
  AdminBlogEditLazyRoute: AdminBlogEditLazyRoute,
  AdminReportEditLazyRoute: AdminReportEditLazyRoute,
  ResumeEditIdLazyRoute: ResumeEditIdLazyRoute,
  ResumeUploadFileLazyRoute: ResumeUploadFileLazyRoute,
  ResumeViewIdLazyRoute: ResumeViewIdLazyRoute,
  VacancyApplyIdLazyRoute: VacancyApplyIdLazyRoute,
  VacancyEditIdLazyRoute: VacancyEditIdLazyRoute,
  VacancyViewIdLazyRoute: VacancyViewIdLazyRoute,
  VacancyViewAllCandidatesLazyRoute: VacancyViewAllCandidatesLazyRoute,
  ResumeViewFileIdLazyRoute: ResumeViewFileIdLazyRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/about",
        "/account-role-choice",
        "/blog",
        "/contacts",
        "/create-resume",
        "/create-vacancy",
        "/login",
        "/policy-page",
        "/register",
        "/user",
        "/vacancies",
        "/admin/current-admin-login",
        "/account/$id",
        "/admin/global-login",
        "/admin/home-page",
        "/password/$id",
        "/post/$id",
        "/report/$id",
        "/account/callback/$userType",
        "/admin/blog/edit",
        "/admin/report/edit",
        "/resume/edit/$id",
        "/resume/upload/file",
        "/resume/view/$id",
        "/vacancy/apply/$id",
        "/vacancy/edit/$id",
        "/vacancy/view/$id",
        "/vacancy/view/all-candidates",
        "/resume/view/file/$id"
      ]
    },
    "/": {
      "filePath": "index.lazy.tsx"
    },
    "/about": {
      "filePath": "about.lazy.tsx"
    },
    "/account-role-choice": {
      "filePath": "account-role-choice.lazy.tsx"
    },
    "/blog": {
      "filePath": "blog.lazy.tsx"
    },
    "/contacts": {
      "filePath": "contacts.lazy.tsx"
    },
    "/create-resume": {
      "filePath": "create-resume.lazy.tsx"
    },
    "/create-vacancy": {
      "filePath": "create-vacancy.lazy.tsx"
    },
    "/login": {
      "filePath": "login.lazy.tsx"
    },
    "/policy-page": {
      "filePath": "policy-page.lazy.tsx"
    },
    "/register": {
      "filePath": "register.lazy.tsx"
    },
    "/user": {
      "filePath": "user.lazy.tsx"
    },
    "/vacancies": {
      "filePath": "vacancies.lazy.tsx"
    },
    "/admin/current-admin-login": {
      "filePath": "admin/current-admin-login.tsx"
    },
    "/account/$id": {
      "filePath": "account/$id.lazy.tsx"
    },
    "/admin/global-login": {
      "filePath": "admin/global-login.lazy.tsx"
    },
    "/admin/home-page": {
      "filePath": "admin/home-page.lazy.tsx"
    },
    "/password/$id": {
      "filePath": "password/$id.lazy.tsx"
    },
    "/post/$id": {
      "filePath": "post/$id.lazy.tsx"
    },
    "/report/$id": {
      "filePath": "report/$id.lazy.tsx"
    },
    "/account/callback/$userType": {
      "filePath": "account/callback/$userType.lazy.tsx"
    },
    "/admin/blog/edit": {
      "filePath": "admin/blog/edit.lazy.tsx"
    },
    "/admin/report/edit": {
      "filePath": "admin/report/edit.lazy.tsx"
    },
    "/resume/edit/$id": {
      "filePath": "resume/edit/$id.lazy.tsx"
    },
    "/resume/upload/file": {
      "filePath": "resume/upload/file.lazy.tsx"
    },
    "/resume/view/$id": {
      "filePath": "resume/view/$id.lazy.tsx"
    },
    "/vacancy/apply/$id": {
      "filePath": "vacancy/apply/$id.lazy.tsx"
    },
    "/vacancy/edit/$id": {
      "filePath": "vacancy/edit/$id.lazy.tsx"
    },
    "/vacancy/view/$id": {
      "filePath": "vacancy/view/$id.lazy.tsx"
    },
    "/vacancy/view/all-candidates": {
      "filePath": "vacancy/view/all-candidates.lazy.tsx"
    },
    "/resume/view/file/$id": {
      "filePath": "resume/view/file/$id.lazy.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
